<template>
  <div class="info-box">
    <div class="head-box">
      <div class="c-flex-space-between c-flex-align-center">
        <p class="p1">{{ $t("user_center.apiManagement") }}</p>
        <div class="btn2">
          <a href="https://github.com/rwaex/APIDocs" target="_blank">
            {{ $t("user_assets.api.check_document") }}
          </a>
        </div>
      </div>
      <p class="p2 mt8">
        {{ $t("user_assets.api.attentionVal1") }}
      </p>
      <p class="p2 mt8">{{ $t("user_assets.api.attentionVal2") }}</p>
      <p class="p2 mt8">
        {{ $t("user_assets.api.attentionVal3") }}
      </p>
      <p class="p2 mt8">
        {{ $t("user_assets.api.attentionVal4") }}
      </p>
    </div>
    <div class="head-box">
      <div class="c-flex-space-between c-flex-align-center mt40">
        <p class="p1">{{ $t("user_assets.api.add") }}</p>
        <div class="btn2" @click="createApi">{{ $t("user_assets.api.create_key") }}</div>
      </div>
      <el-form>
        <div class="input-box">
          <div class="c-flex1 c-flex-column">
            <p class="p3 mt24">{{ $t("user_assets.api.fill_info") }}</p>
            <el-form-item :label="$t('user_assets.api.remarks')">
              <el-input
                v-model="createData.description"
                :placeholder="$t('user_assets.api.remarks_placeholder')"
              />
            </el-form-item>
            <el-form-item :label="$t('user_assets.api.bind_ip')">
              <el-input
                v-model="createData.ipaddress"
                :placeholder="$t('user_assets.api.bind_placeholder')"
              />
            </el-form-item>
          </div>
          <div class="c-flex1 c-flex-column">
            <p class="p3 mt24">{{ $t("user_assets.api.role_api") }}</p>
            <el-form-item class="mt12">
              <el-checkbox
                :true-label="1"
                :false-label="0"
                v-model="createData.permGet"
              >
                <span class="p2">{{ $t("user_assets.api.api_check") }}</span>
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox
                style="margin-top: 20px"
                :true-label="1"
                :false-label="0"
                v-model="createData.permTrade"
              >
                <span class="p2">{{ $t("user_assets.api.api_trade") }}</span>
              </el-checkbox>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <p class="p1 mt40">{{ $t("user_assets.api.my_key") }}</p>
    <div class="box2 c-flex1 c-flex-column">
      <NoData v-if="apiTable.length <= 0" />
      <el-table
        v-else
        :data="apiTable"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
      >
        <el-table-column :label="$t('user_assets.api.id')">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="description"
          :label="$t('user_assets.api.remarks')"
        >
        </el-table-column>
        <el-table-column prop="ipaddress" align="center" label="IP">
        </el-table-column>
        <el-table-column align="right" :label="$t('user_assets.api.operation')">
          <template slot-scope="scope">
            <label
              style="cursor: pointer"
              class="font_color_green"
              @click="deleteApi(scope.row)"
              >{{ $t("user_assets.api.delete_api") }}
            </label>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :visible.sync="resultFlag"
      :show-close="false"
      append-to-body
      :title="description + $t('user_assets.api.alert_title')"
    >
      <img
        class="close-img"
        alt="close-icon.png"
        @click="resultFlag = false"
        src="@/assets/img/images/icon/close-icon.png"
      />
      <el-form>
        <el-form-item :label="$t('user_assets.api.visit_key')">
          <el-input v-model="visit_key" readonly />
        </el-form-item>
        <el-form-item :label="$t('user_assets.api.private_key')">
          <el-input v-model="private_key" readonly type="textarea" />
        </el-form-item>
      </el-form>
      <div class="tips-box">
        <img
          src="@/assets/img/images/icon/warning-icon.png"
          alt="warning-icon.png"
        />
        {{ $t("user_assets.api.show_once") }}
      </div>
      <div class="tips-box mt20">
        <img
          src="@/assets/img/images/icon/warning-icon.png"
          alt="warning-icon.png"
        />
        {{ $t("user_assets.api.tips_val_1") }}
      </div>
      <div class="mt20">
        <qriously
          value="https://rwaex.io/h5/download/download.html"
          :size="130"
          class="qr"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/components/NoData/index";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      resultFlag: false,
      description: "",
      visit_key: "f983c3c7-e5f8-4537a-452s-4s141254676",
      private_key: "f983c3c7-e5f8-4537a-452s-4s141254676",
      createData: {
        description: "",
        ipaddress: "",
        permGet: 0,
        permTrade: 0,
      },
      tableParam: {
        pageNumber: 1,
        pageSize: 10,
      },
      total: 0,
      apiTable: [],
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  created() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.$axios.post("/userAPI/listAll", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.apiTable = res.data.data;
        }
      });
    },
    onCopy: function (e) {
      alert(this.$t("user_assets.copy_success"));
    },
    onError: function (e) {
      alert(this.$t("user_assets.copy_error"));
    },
    //创建API
    createApi() {
      if (this.createData.description === "") {
        this.$message({
          type: "warning",
          message: this.$t("validate.description_require"),
        });
      } else if (
        this.createData.permTrade === 0 &&
        this.createData.permGet === 0
      ) {
        this.$message({
          type: "warning",
          message: this.$t("validate.roles_require"),
        });
      } else {
        this.$axios.post("/userAPI/create", this.createData).then((res) => {
          if (res.data.code === this.errorCode.ok) {
            //console.log(res.data.data);
            this.visit_key = res.data.data.accessKey;
            this.private_key = res.data.data.secretKey;
            this.description = res.data.data.description;
            this.resultFlag = true;
            this.getTableData();
            this.createData = {
              description: "",
              ipaddress: "",
              permGet: 0,
              permTrade: 0,
            };
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      }
    },
    //删除API
    deleteApi(row) {
      this.$confirm(
        this.$t("user_assets.api.delete_confirm") + row.description,
        this.$t("user_center.tip"),
        {
          confirmButtonText: this.$t("user_assets.api.delete_api"),
          cancelButtonText: this.$t("user_assets.api.cancel"),
          type: "warning",
        },
      )
        .then(() => {
          this.$axios
            .post("/userAPI/remove", { accessKey: row.accessKey })
            .then((res) => {
              if (res.data.code === this.errorCode.ok) {
                this.$message({
                  type: "success",
                  message: this.$t("user_assets.api.delete_success"),
                });
                this.getTableData();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  position: relative;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__body {
    padding-top: 0px;
  }
}
.close-img {
  top: 20px;
  right: 20px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
}
.info-box {
  padding: 40px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;
  .head-box {
    padding-bottom: 36px;
    border-bottom: 1px solid #e2e3e3;
  }
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 24px;
    color: #333333;
  }
  .p2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 18px;
    color: #333333;
  }
  .btn2 {
    width: 112px;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: #4063ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
  }
  .item-box {
    display: flex;
    margin-top: 32px;
    justify-content: space-between;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .item-btn {
      gap: 32px;
      display: flex;
      align-items: center;
    }
  }
  .input-box {
    gap: 120px;
    display: flex;
    justify-content: space-between;
  }
  /deep/ .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
}
.box2 {
  margin-top: 20px;
  /deep/.table-head {
    background: rgba(234, 235, 237, 0.5);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
}
.tab-box {
  gap: 40px;
  display: flex;
  border-bottom: 1px solid #e2e3e3;
  div {
    padding: 20px 0;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
  .sel {
    font-weight: 800;
    font-size: 18px;
    color: #333333;
    position: relative;
  }
  .sel::before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    bottom: 0;
    border-bottom: 1px solid #4063ff;
  }
}

/deep/ .el-textarea__inner {
  border: none;
  background-color: rgba(214, 216, 219, 0.3);
}

.tips-box {
  gap: 15px;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: #e1eaff;
  border-radius: 9px 9px 9px 9px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #4063ff;
  img {
    width: 26px;
    height: 26px;
  }
}
</style>
